import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { withSubscriptions } from 'Components/WithSubscriptions';
import { CenterFrameLayout } from 'Layouts';
import { SheerIdBanner } from 'Features/SheerIdPromoBanner/SheerIdBanner';
import { PlanSelection } from 'Features/Plans/PlanSelection/PlanSelection';
import { isFirstResponderChurned, isMilitaryChurned } from 'Utils/SheerIdHelpers';
import { usePlans } from 'Hooks/usePlans';
import './SignUpPlansContainer.css';

const SignUpPlansComponent = () => {
  const { allPlans, selectedPlan } = usePlans();

  const { enableSheerIdBanner } = useSelector((s) => s.appConfig.defaultConfig);
  const subscription = useSelector((s) => s.subscription);

  const isSheerIdChurned =
    isFirstResponderChurned(subscription.isChurnedUser, subscription.restartChurnedUserDetails) ||
    isMilitaryChurned(subscription.isChurnedUser, subscription.restartChurnedUserDetails);

  const showSheerIdBanner = useMemo(
    () => enableSheerIdBanner && !!allPlans.length && !isSheerIdChurned,
    [enableSheerIdBanner, allPlans, isSheerIdChurned]
  );

  useEffect(() => {
    trackEvent(TRACKING_ENUMS.EVENT_PLAN_SELECT_START);
  }, []);

  return (
    <CenterFrameLayout
      title="Choose a Plan"
      showLoader={!allPlans.length}
      modernLayout
      customClass="signUpPlansContainer"
    >
      {showSheerIdBanner && <SheerIdBanner />}
      <PlanSelection plans={allPlans} selectedPlan={selectedPlan} />
    </CenterFrameLayout>
  );
};
export const SignUpPlansContainer = withSubscriptions(SignUpPlansComponent);
